
module.exports = function (obj, key) {
  return obj.hasOwnProperty(key);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/util/lib/object/has.js
// module id = 416
// module chunks = 0